import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
export default class VotingProgressBar extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "currentCategoryIndex", 0);
    _defineProperty(this, "showConfetti", false);
    _defineProperty(this, "confettiShown", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.checkCompletion();
  }
  onupdate(vnode) {
    super.onupdate(vnode);
    this.checkCompletion();
  }
  checkCompletion() {
    const votedCount = this.attrs.votedCount;
    const totalCount = this.attrs.totalCount;
    if (votedCount === totalCount && totalCount > 0 && !this.confettiShown) {
      this.showConfetti = true;
      this.confettiShown = true;

      // Hide confetti after animation
      setTimeout(() => {
        this.showConfetti = false;
        m.redraw();
      }, 4000);
    }
  }
  view() {
    const votedCount = this.attrs.votedCount;
    const totalCount = this.attrs.totalCount;
    const categoryIds = this.attrs.categoryIds;
    const onNavigate = this.attrs.onNavigate;
    const selectedCategoryId = this.attrs.selectedCategoryId;
    const onCategoryChange = this.attrs.onCategoryChange;
    const isComplete = votedCount === totalCount && totalCount > 0;
    const progressPercent = totalCount > 0 ? votedCount / totalCount * 100 : 0;
    const isFilterMode = !!selectedCategoryId && !!onCategoryChange;
    return m("div", {
      className: `VotingProgressBar ${isComplete ? 'VotingProgressBar--complete' : ''} ${this.showConfetti ? 'VotingProgressBar--confetti' : ''}`
    }, this.showConfetti ? this.renderConfetti() : null, m("div", {
      className: "VotingProgressBar-content"
    }, m("div", {
      className: "VotingProgressBar-progress"
    }, m("div", {
      className: "VotingProgressBar-progressTrack"
    }, m("div", {
      className: "VotingProgressBar-progressFill",
      style: {
        width: `${progressPercent}%`
      }
    })), m("span", {
      className: "VotingProgressBar-text"
    }, isComplete ? app.translator.trans('huseyinfiliz-awards.forum.progress.complete') : app.translator.trans('huseyinfiliz-awards.forum.progress.voted', {
      count: votedCount,
      total: totalCount
    }))), m("div", {
      className: "VotingProgressBar-nav"
    }, m(Button, {
      className: "Button Button--icon",
      icon: "fas fa-chevron-left",
      onclick: () => this.navigate(-1, categoryIds, onNavigate, selectedCategoryId, onCategoryChange),
      disabled: categoryIds.length === 0,
      title: app.translator.trans('huseyinfiliz-awards.forum.progress.prev')
    }, app.translator.trans('huseyinfiliz-awards.forum.progress.prev')), m(Button, {
      className: "Button Button--icon",
      icon: "fas fa-chevron-right",
      onclick: () => this.navigate(1, categoryIds, onNavigate, selectedCategoryId, onCategoryChange),
      disabled: categoryIds.length === 0,
      title: app.translator.trans('huseyinfiliz-awards.forum.progress.next')
    }, app.translator.trans('huseyinfiliz-awards.forum.progress.next')))));
  }
  navigate(direction, categoryIds, onNavigate, selectedCategoryId, onCategoryChange) {
    if (categoryIds.length === 0) return;

    // Filter navigation mode: navigate between category filters
    if (selectedCategoryId && onCategoryChange) {
      const currentIndex = categoryIds.indexOf(selectedCategoryId);
      if (currentIndex === -1) return;
      let newIndex = currentIndex + direction;
      if (newIndex < 0) newIndex = categoryIds.length - 1;
      if (newIndex >= categoryIds.length) newIndex = 0;
      onCategoryChange(categoryIds[newIndex]);
      return;
    }

    // Scroll mode: scroll between categories on the page
    let visibleCategoryId = null;
    for (const id of categoryIds) {
      const element = document.getElementById(`category-${id}`);
      if (element) {
        const rect = element.getBoundingClientRect();
        if (rect.top >= 0 && rect.top < window.innerHeight / 2) {
          visibleCategoryId = id;
          break;
        }
      }
    }
    let currentIndex = visibleCategoryId ? categoryIds.indexOf(visibleCategoryId) : 0;
    if (currentIndex === -1) currentIndex = 0;
    let newIndex = currentIndex + direction;
    if (newIndex < 0) newIndex = categoryIds.length - 1;
    if (newIndex >= categoryIds.length) newIndex = 0;
    onNavigate(categoryIds[newIndex]);
  }
  renderConfetti() {
    const colors = ['#ffd700', '#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#ffeaa7', '#dfe6e9'];
    const pieces = [];
    for (let i = 0; i < 30; i++) {
      const color = colors[Math.floor(Math.random() * colors.length)];
      const left = Math.random() * 100;
      const delay = Math.random() * 0.5;
      const size = 6 + Math.random() * 6;
      const rotation = Math.random() * 360;
      pieces.push(m("div", {
        key: i,
        className: "VotingProgressBar-confettiPiece",
        style: {
          left: `${left}%`,
          animationDelay: `${delay}s`,
          backgroundColor: color,
          width: `${size}px`,
          height: `${size}px`,
          transform: `rotate(${rotation}deg)`
        }
      }));
    }
    return m("div", {
      className: "VotingProgressBar-confettiContainer"
    }, pieces);
  }
}
flarum.reg.add('huseyinfiliz-awards', 'forum/components/VotingProgressBar', VotingProgressBar);